import React from 'react';
import Link from 'next/link';

import { IMenuItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';
import * as ST from '@r1-frontend/entities/Layout/Header/mobile/components/Card/styled';

interface IProps {
    clickHandler?: () => void,
    itemMenuType?: string,
    onClickHandlerGA: (item: string, menuType?: string) => void,
    children?: JSX.Element | JSX.Element[],
    childItem: IMenuItem,
    isAvailable: boolean,
    isPromoted?: boolean,
}

export const CardChildItemHoc = ({
    childItem,
    clickHandler,
    onClickHandlerGA,
    itemMenuType,
    isAvailable,
}: IProps) => {

    const clickHandlerWrapper = () => {
        if (typeof clickHandler === 'function') {
            clickHandler();
        }
        onClickHandlerGA(childItem.title, itemMenuType);
    };

    return (
        <ST.CardChildItem
            text={childItem.title}
            key={childItem.id}
            isAvailable={isAvailable}
        >
            <Link href={childItem.link} passHref prefetch={false}>
                <ST.CardChildLink
                    isPromoted={!!childItem.promoted}
                    onClick={clickHandlerWrapper}
                >
                    {childItem?.title}
                </ST.CardChildLink>
            </Link>
        </ST.CardChildItem>
    );
};
